"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Update Data Record',
    description: 'Update a new data record in a collection using its id',
});
//# sourceMappingURL=update-data-record.js.map